import {
	fetchContactGroupsList,
	renameContactGroups,
	updateContactGroupSettings
} from 'src/api/contactGroupsApi';
import * as actionTypes from '../actions';

export const updateContactGroupAutoSyncToResidents =
	(projectId, groupId, autoSyncToResidents) => async (dispatch, getState) => {
		try {
			const updated = await updateContactGroupSettings(projectId, groupId, {
				autoSyncToResidents
			});

			const currentDetails = getState().customers.contactGroupDetails;
			if (currentDetails?.data?.id === groupId) {
				dispatch(
					actionTypes.contactGroupDetailsFetchSuccess({
						...currentDetails,
						data: {
							...currentDetails.data,
							autoSyncToResidents
						}
					})
				);
			}

			await dispatch(
				actionTypes.showToast({
					type: 'success',
					body: autoSyncToResidents
						? 'Auto Sync to Residents enabled'
						: 'Auto Sync to Residents disabled'
				})
			);

			return updated;
		} catch (error) {
			await dispatch(
				actionTypes.showToast({
					type: 'error',
					body: 'Failed to update Auto Sync to Residents'
				})
			);
			throw error;
		}
	};

export const renameContactGroup = (projectId, data) => async (dispatch, getState) => {
	await dispatch(actionTypes.setLoader(true));
	try {
		await renameContactGroups(projectId, data);

		// Patch local store — no need to refetch the full list (and wipe contact counts)
		const { contactGroups, contactGroupsList } = getState().customers;
		if (contactGroups?.data) {
			dispatch(
				actionTypes.contactGroupsFetchSuccess({
					...contactGroups,
					data: contactGroups.data.map((group) =>
						group.id === data.groupId ? { ...group, groupName: data.groupName } : group
					)
				})
			);
		}
		if (contactGroupsList?.data) {
			dispatch(
				actionTypes.contactGroupsListFetchSuccess({
					...contactGroupsList,
					data: contactGroupsList.data.map((group) =>
						group.id === data.groupId ? { ...group, groupName: data.groupName } : group
					)
				})
			);
		}
	} catch (error) {
		await dispatch(
			actionTypes.showToast({
				type: 'error',
				body: 'Rename Contact Group error'
			})
		);
	}

	await dispatch(actionTypes.setLoader(false));
};

export const fetchContactGroupsListRequest = (projectId) => async (dispatch) => {
	await dispatch(actionTypes.setLoader(true));
	await dispatch(actionTypes.contactGroupsListFetchPending());
	try {
		const contactGroupsList = await fetchContactGroupsList(projectId);
		await dispatch(actionTypes.contactGroupsListFetchSuccess(contactGroupsList));
	} catch (error) {
		await dispatch(actionTypes.contactGroupsListFetchError(error));
		await dispatch(
			actionTypes.showToast({
				type: 'error',
				body: 'Fetch Contact Groups List error'
			})
		);
	}

	await dispatch(actionTypes.setLoader(false));
};
